import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { of, throwError } from 'rxjs';
import { retry } from 'rxjs/operators';

class RetryHttpInterceptor {
    intercept(request, next) {
        return next
            .handle(request)
            .pipe(retry({
            count: 2,
            delay: error => {
                if (!error.status) {
                    console.log(`Retrying ${request.urlWithParams}`);
                    return of(100);
                }
                return throwError(() => error);
            }
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.5", ngImport: i0, type: RetryHttpInterceptor, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.5", ngImport: i0, type: RetryHttpInterceptor, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.5", ngImport: i0, type: RetryHttpInterceptor, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { RetryHttpInterceptor };
